import elementEn from "./element.js";
import customEn from "./custom.js";

export default {
  ...elementEn,
  ...customEn,
};
